<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        Thêm mới group
      </v-card-title>
      <v-card-text>
        <v-text-field
          ref="groupName"
          v-model="groupName"
          placeholder="Tên group"
          label="Tên group"
          :error="!!errorGroupName"
          :error-messages="errorGroupName"
        ></v-text-field>
        <v-select
          :items="roles"
          v-model="groupRoles"
          label="Roles"
          item-text="displayName"
          item-value="id"
          max-height="400"
          return-object
          placeholder="Roles"
          multiple
        ></v-select>
         <v-text-field
          ref="groupRemark"
          v-model="groupRemark"
          label="Ghi chú"
          placeholder="Ghi chú"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="addNewGroup" :loading="loading">Thêm</v-btn>
        <v-btn color="grey" flat @click="close">Hủy</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    roles: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    dialog: false,
    groupName: '',
    groupRemark: '',
    groupRoles: [],
    errorGroupName: '',
    loading: false
  }),

  methods: {
    ...mapActions(['addGroupRole']),

    open () {
      this.dialog = true;
    },

    close () {
      this.dialog = false;
      this.reset();
    },

    async addNewGroup () {
      if (!this.groupName) {
        this.errorGroupName = 'Vui lòng không để trống trường này';
        return;
      }
      else { this.errorGroupName = '' }
      let data = {
        name: this.groupName,
        roles: this.groupRoles.map(item => item.id),
        remark: this.groupRemark
      };
      this.loading = true;
      await this.addGroupRole(data).then(res => {
        this.$emit('success', true);
        this.loading = false;
        this.close();
      }).catch(() => {
        window.getApp.showMessage('Có lỗi xảy ra, vui lòng thử lại', 'error');
        this.loading = false;
      });
    },

    reset () {
      this.groupName = '';
      this.remark = '';
      this.groupRoles = [];
      this.errorGroupName = '';
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/grouprole/DialogAddNewGroup.vue